import { render, staticRenderFns } from "./PaymentSelectCoin.vue?vue&type=template&id=f5f4cd0a&scoped=true&"
import script from "./PaymentSelectCoin.vue?vue&type=script&lang=js&"
export * from "./PaymentSelectCoin.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSelectCoin.vue?vue&type=style&index=0&id=f5f4cd0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f4cd0a",
  null
  
)

export default component.exports